import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  elapsed_ms,
  format_elapsed,
  timer_color_css
} from '../../util_components/instant_alert/instant_timer';

// Self-ticking so only live instant rows re-render each second, not the table.
function InstantElapsed({ created_at_iso }) {
  const [now, set_now] = useState(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => set_now(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);
  const ms = elapsed_ms(created_at_iso, now);
  if (ms === null) return null;
  return (
    <span
      className="text-xs whitespace-nowrap"
      style={{ color: timer_color_css(ms), fontWeight: 600, fontVariantNumeric: 'tabular-nums' }}
    >
      {format_elapsed(ms)}
    </span>
  );
}

InstantElapsed.propTypes = {
  created_at_iso: PropTypes.string
};

InstantElapsed.defaultProps = {
  created_at_iso: ''
};

export default InstantElapsed;
